import { FC } from "react";
import KeyPoints from "./KeyPoints";
import { InnerWrapper } from "./LiveBlog.styled";
import Posts from "./Posts";

interface Props {
  liveblog: {
    liveblogKeypoints: string;
    liveblogKeypointsTitle: string;
    liveblog: string;
  };
  isLiveBlog: boolean;
}

const LiveBlog: FC<Props> = ({ isLiveBlog, liveblog }) => {
  if (!isLiveBlog) {
    return null;
  }
  return (
    <div>
      <InnerWrapper>
        <KeyPoints
          title={liveblog?.liveblogKeypointsTitle}
          keypoints={liveblog?.liveblogKeypoints}
        />
        <Posts id={liveblog.liveblog} />
      </InnerWrapper>
    </div>
  );
};
export default LiveBlog;
